import { render, staticRenderFns } from "./TransferInformationTab.vue?vue&type=template&id=704fa3a8"
import script from "./TransferInformationTab.vue?vue&type=script&lang=js"
export * from "./TransferInformationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports